import './spinner.css';
import React from 'react';
export const Spinner = () => {
return (
  <div className={'spinner'} />
)
}